function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_163",
  "data-name": "Path 163",
  d: "M31.22,19.327,13.1,29.354A2.079,2.079,0,0,0,12,31.171V51.236a2.084,2.084,0,0,0,1.1,1.817L31.223,63.088a2.283,2.283,0,0,0,2.19,0L51.536,53.053a2.091,2.091,0,0,0,1.09-1.817V31.171a2.084,2.084,0,0,0-1.1-1.817L33.41,19.327a2.284,2.284,0,0,0-2.194,0M124.463,37.39l-3.021,1.669a.342.342,0,0,0-.181.3v3.346a.35.35,0,0,0,.181.3l3.021,1.673a.378.378,0,0,0,.366,0l3.021-1.673a.35.35,0,0,0,.181-.3V39.363a.346.346,0,0,0-.185-.3l-3.021-1.669a.365.365,0,0,0-.362,0",
  transform: "translate(32.319 6.976)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M64.706,17.037l-8.823-4.923a.9.9,0,0,0-1.333.783l0,29.738-8.136-4.5a2.284,2.284,0,0,0-2.194,0h0L26.1,48.16A2.078,2.078,0,0,0,25,49.973V70.039a2.084,2.084,0,0,0,1.1,1.817L44.223,81.89a2.283,2.283,0,0,0,2.19,0L64.536,71.856a2.087,2.087,0,0,0,1.09-1.817V18.6A1.8,1.8,0,0,0,64.706,17.037ZM54.051,65.4l-8.236,4.561a1.032,1.032,0,0,1-.993,0L36.582,65.4a.942.942,0,0,1-.5-.827V55.447a.951.951,0,0,1,.5-.827l8.24-4.557h0a1.031,1.031,0,0,1,.5-.126,1.073,1.073,0,0,1,.5.126l8.236,4.557a.956.956,0,0,1,.5.831v9.122A.949.949,0,0,1,54.051,65.4Z",
  transform: "translate(67.331 -12)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M31.22,19.327,12,51.236a2.084,2.084,0,0,0,1.1,1.817L31.223,63.088a2.283,2.283,0,0,0,2.19,0L52.626,31.171a2.084,2.084,0,0,0-1.1-1.817L33.41,19.327a2.284,2.284,0,0,0-2.194,0",
  transform: "translate(32.319 6.976)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M31.22,19.327,13.1,29.354A2.079,2.079,0,0,0,12,31.171L31.22,63.088a2.283,2.283,0,0,0,2.19,0L51.533,53.053a2.088,2.088,0,0,0,1.093-1.817L33.41,19.327a2.284,2.284,0,0,0-2.194,0",
  transform: "translate(32.319 6.976)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M176.179,29.308,158.06,19.281a2.284,2.284,0,0,0-2.194,0h0L137.747,29.308a2.12,2.12,0,0,0-1.1,1.858V51.15a2.124,2.124,0,0,0,1.1,1.858l18.126,10.035a2.263,2.263,0,0,0,2.19,0l8.358-4.628a1.108,1.108,0,0,0-.007-1.943l-18.186-9.924a.972.972,0,0,1-.5-.842V36.6a.932.932,0,0,1,.48-.816l8.254-4.565h0a1.03,1.03,0,0,1,.5-.126,1.073,1.073,0,0,1,.5.126l8.254,4.569a.932.932,0,0,1,.48.816v7.431a.89.89,0,0,0,.447.772.907.907,0,0,0,.894,0l8.856-5.145a1.783,1.783,0,0,0,.886-1.54V31.173A2.127,2.127,0,0,0,176.179,29.308Zm-136.65,0L21.41,19.281a2.284,2.284,0,0,0-2.194,0h0L1.1,29.308A2.12,2.12,0,0,0,0,31.166v27.57a.89.89,0,0,0,.447.772.907.907,0,0,0,.894,0L10.2,54.359a1.78,1.78,0,0,0,.883-1.54V36.595a.932.932,0,0,1,.48-.816l8.254-4.565h0a1.031,1.031,0,0,1,.5-.126,1.073,1.073,0,0,1,.5.126l8.254,4.569a.932.932,0,0,1,.48.816V52.823a1.776,1.776,0,0,0,.886,1.54l8.856,5.145a.887.887,0,0,0,1.337-.772V31.169A2.125,2.125,0,0,0,39.529,29.308Z",
  transform: "translate(0 6.852)"
});

function SvgNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-nodejs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.276,
    height: 70.344,
    viewBox: "0 0 177.276 70.344",
    transform: "translate(0 20)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/Node.6d724124.svg";
export { ForwardRef as ReactComponent };